import { render } from "./UI2LayoutEmpty.vue?vue&type=template&id=5ce67aa5"
const script = {}

import "./UI2LayoutEmpty.vue?vue&type=style&index=0&id=5ce67aa5&lang=scss"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__